module.exports = __webpack_public_path__ + "img/logo.067bcb7d.png";